import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=12d3fa6a&scoped=true"
import script from "./VFooter.vue?vue&type=script&lang=js"
export * from "./VFooter.vue?vue&type=script&lang=js"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=12d3fa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3fa6a",
  null
  
)

export default component.exports